import { render, staticRenderFns } from "./workplace.vue?vue&type=template&id=f8573e5a&scoped=true"
import script from "./workplace.vue?vue&type=script&lang=js"
export * from "./workplace.vue?vue&type=script&lang=js"
import style0 from "./workplace.vue?vue&type=style&index=0&id=f8573e5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8573e5a",
  null
  
)

export default component.exports